import { DatabaseRecord } from "../repos/table.repo";
import { TollAreaModel } from "./toll-area/toll-area.model";

export interface ReadMeterPeriodModel extends DatabaseRecord {
    waterFactoryId: string;
    tollArea: TollAreaModel;
    tollAreaId?: string,
    fromDate: Date;
    toDate: Date;
    year: number;
    month: number;
    waterUserTotal: number,
    waterIndexTotal: number,
    isAllowReading: boolean;
    lockTime: Date;
    provinceId?: string,
    districtId?: string,
    wardId?: string
}

export class ReadMeterPeriodModelFactory {
    static getEmpty(): ReadMeterPeriodModel {
        return {
            id: "",
            waterFactoryId: "",
            tollArea: {} as TollAreaModel,
            fromDate: new Date(),
            toDate: new Date(),
            year: 0,
            month: 0,
            waterUserTotal: 0,
            waterIndexTotal: 0,
            isAllowReading: false,
            lockTime: new Date()
        };
    }
}